import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

/* Layout */
import Layout from '@/layout'

/**
 * constantRoutes
 * a base page that does not have permission requirements
 * all roles can be accessed
 */
export const constantRoutes = [

  {
    path: '/login',
    component: () => import('@/views/login/index'),
    hidden: true
  },

  {
    path: '/404',
    component: () => import('@/views/error-page/404'),
    hidden: true
  },
  {
    path: '/401',
    component: () => import('@/views/error-page/401'),
    hidden: true
  },

  {
    path: '/',
    component: Layout,
    redirect: '/controlPanel',
    children: [
      {
        path: 'controlPanel',
        component: () => import('@/views/controlPanel/index'),
        name: 'controlPanel',
        meta: { title: '控制面板', icon: 'iconfont icon-kongzhimianban-copy', affix: true }
      }
    ]
  }

]

/**
 * asyncRoutes
 * the routes that need to be dynamically loaded based on user roles
 */
export const asyncRoutes = [
  {

    path: '/inventoryQuery',
    component: 'Layout',
    children: [
      {
        path: '/inventoryQuery',
        component: 'inventorySystemManagement/inventoryQuery/index',
        name: 'inventoryQuery',
        meta: { title: '库存查询',icon: 'iconfont icon-kucunchaxun1' }
      }
    ]
  },
  {
    path: '/overseasInventoryQuery',
    component: 'Layout',
    children: [
      {
        path: '/overseasInventoryQuery',
        component: 'overseasInventory/overseasInventoryQuery/index',
        name: 'overseasInventoryQuery',
        meta: {title: '海外库存查询', icon: 'iconfont icon-a-jiageqingdan1'}
      },
    ]
  },
  {
    path: '/createQuotations',
    component: 'Layout',
    name: 'createQuotations',
    meta: {
      title: '生成报价单',
      icon: 'iconfont icon-provider_menu09',
      roles: ['admin']
    },
    children: [
      {
        path: '/createQuotation',
        component: 'createQuotation/index',
        name: 'createQuotation',
        meta: {title: '生成报价单', icon: 'iconfont icon-provider_menu09'},
      }
    ]
  },
  {
    path: '/createContracts',
    component: 'Layout',
    name: 'createContracts',
    meta: {
      title: '生成合同',
      icon: 'iconfont icon-shengchenghetong1',
      roles: ['admin']
    },
    children: [
      {
        path: '/createContract',
        component: 'createContract/index',
        name: 'createContract',
        meta: {title: '生成合同', icon: 'iconfont icon-shengchenghetong1'},
      }
    ]
  },
  {
    path: '/bearingQuotations',
    component: 'Layout',
    name: 'bearingQuotations',
    meta: {
      title: '轴承报价系统',
      icon: 'iconfont icon-xiangmuzijinguanli',
      roles: ['admin']
    },
    children: [
      {
        path: '/bearingQuotation',
        component: 'bearingQuotation/index',
        name: 'bearingQuotation',
        meta: { title: '轴承报价系统' ,icon: 'iconfont icon-xinghao' },
      }
    ]
  },
  {
    path: '/customerInfo',
    component: 'Layout',
    name: 'customerInfo',
    meta: {
      title: '客户信息',
      icon: 'iconfont icon-kehuxinxi',
      roles: ['admin']
    },
    children: [
      {
        path: '/customerCategory',
        component: 'customerInfo/customerCategory/index',
        name: 'customerCategory',
        meta: {title: '客户分类',icon: 'iconfont icon--kehufenlei'}
      },
      {
        path: '/customerInformation',
        component: 'customerInfo/customerInformation/index',
        name: 'customerInformation',
        meta: {title: '客户信息',icon: 'iconfont icon-kehuxinxi'}
      },
      {
        path: '/customerQuotation',
        component: 'customerInfo/customerQuotation/index',
        name: 'customerQuotation',
        meta: {title: '客户报价',icon: 'iconfont icon-gerenkehubaojia'}
      },
      {
        path: '/customerContract',
        component: 'customerInfo/customerContract/index',
        name: 'customerContract',
        meta: {title: '客户合同',icon: 'iconfont icon-kehuhetong'}
      },
      {
        path: '/generateContract/:id',
        component: 'customerInfo/generateContract/index',
        name: 'generateContract',
        hidden: true,
        meta: {title: '生成合同',icon: 'iconfont icon-kehuhetong'}
      }
    ]
  },
  {
    path: '/inventorySystemManagement',
    component: 'Layout',
    name: 'inventorySystemManagement',
    meta: {
      title: '库存系统管理',
      icon: 'iconfont icon-caigourukuguanli',
      roles: ['admin']
    },
    children: [
      {
        path: '/category',
        component: 'inventorySystemManagement/category/index',
        name: 'category',
        meta: { title: '商品分类',icon: 'iconfont icon-shangpinfenlei1' }
      },
      {

        path: '/inventoryQuerys',
        component: 'inventorySystemManagement/inventoryQuery/index',
        name: 'inventoryQuerys',
        meta: { title: '库存查询',icon: 'iconfont icon-kucunchaxun1' }
      },
      {

        path: '/supplier',
        component: 'inventorySystemManagement/supplier/index',
        name: 'supplier',
        meta: { title: '供应商',icon: 'iconfont icon-gongyingshangdailishang' }
      },
      {

        path: '/outbound',
        component: 'inventorySystemManagement/outbound/index',
        name: 'outbound',
        meta: { title: '出库',icon: 'iconfont icon-yuchuku' }
      },
      {

        path: '/accessHistory',
        component: 'inventorySystemManagement/accessHistory/index',
        name: 'accessHistory',
        meta: { title: '出入历史查询',icon: 'iconfont icon-lishichaxun' }
      }
    ]
  },
  {
    path: '/overseasInventory',
    component: 'Layout',
    name: 'overseasInventory',
    meta: {
      title: '海外库存',
      icon: 'iconfont icon-haiwaikucun',
      roles: ['admin']
    },
    children: [
      {
        path: '/uploadPrice',
        component: 'overseasInventory/uploadPrice/index',
        name: 'uploadPrice',
        meta: {title: '价格列表', icon: 'iconfont icon-shangchuan'}
      },
      {
        path: '/overseasInventoryQuerys',
        component: 'overseasInventory/overseasInventoryQuery/index',
        name: 'overseasInventoryQuerys',
        meta: {title: '海外库存查询', icon: 'iconfont icon-a-jiageqingdan1'}
      },
      {
        path: '/batchManagement',
        component: 'overseasInventory/batchManagement/index',
        name: 'batchManagement',
        meta: {title: '库存批量管理', icon: 'iconfont icon-kucunguanli'}
      },
      {
        path: '/overseaSupplier',
        component: 'overseasInventory/overseaSupplier/index',
        name: 'overseaSupplier',
        meta: { title: '供应商',icon: 'iconfont icon-gongyingshangdailishang' }
      },
      {
        path: '/rate',
        component: 'overseasInventory/rate/index',
        name: 'rate',
        meta: { title: '汇率列表',icon: 'iconfont icon-huishuai' }
      }
    ]
  },
  {
    path: '/basicSettings',
    component: 'Layout',
    name: 'basicSettings',
    meta: {
      title: '基础设置',
      icon: 'iconfont icon-jichushezhi-2',
      roles: ['admin']
    },
    children: [
      {
        path: '/companyInfo',
        component: 'basicSettings/companyInfo/index',
        name: 'companyInfo',
        meta: { title: '公司信息',icon: 'iconfont icon-gongsixinxi1' }
      },
      {
        path: '/userManagement',
        component: 'basicSettings/userManagement/index',
        name: 'userManagement',
        meta: { title: '用户管理',icon: 'iconfont icon-yonghuguanli' }
      }
    ]
  },
  { path: '*', redirect: '/404', hidden: true }
]

const createRouter = () => new Router({
  // mode: 'history', // require service support
  scrollBehavior: () => ({ y: 0 }),
  routes: constantRoutes
})

const router = createRouter()

// Detail see: https://github.com/vuejs/vue-router/issues/1234#issuecomment-357941465
export function resetRouter() {
  const newRouter = createRouter()
  router.matcher = newRouter.matcher // reset router
}

export default router
